import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.reduce.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "login-container"
};
const _hoisted_2 = {
  class: "login-title"
};
const _hoisted_3 = {
  style: {
    "width": "30%",
    "float": "right",
    "text-align": "right",
    "height": "38px"
  }
};
const _hoisted_4 = ["src"];
import { getCaptcha } from '@/api/system/auth';
import Particle from './Particle.vue';
import defaultSetting from '@/settings.js';
import useStore from '@/store';
import { onMounted, reactive, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {
    const validateUsername = (rule, value, callback) => {
      if (value == null || value === '') {
        callback(new Error('请输入用户名'));
      } else if (value.length < 4) {
        callback(new Error('用户名长度不能小于4个字符'));
      } else if (value.length > 20) {
        callback(new Error('用户名长度不能大于20个字符'));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value == null || value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 6) {
        callback(new Error('密码长度不能小于6个字符'));
      } else if (value.length > 20) {
        callback(new Error('密码长度不能大于20个字符'));
      } else {
        callback();
      }
    };
    const validateCaptcha = (rule, value, callback) => {
      if (value == null || value === '') {
        callback(new Error('请输入验证码'));
      } else if (value.length !== 4) {
        callback(new Error('验证码长度为4个字符'));
      } else {
        callback();
      }
    };
    const title = ref(defaultSetting.title);
    const loginForm = reactive({
      username: '',
      password: '',
      captchaCode: '',
      captchaId: ''
    });
    const loginRules = {
      username: [{
        required: true,
        trigger: 'blur',
        validator: validateUsername
      }],
      password: [{
        required: true,
        trigger: 'blur',
        validator: validatePassword
      }],
      captchaCode: [{
        required: true,
        trigger: 'blur',
        validator: validateCaptcha
      }]
    };
    const router = useRouter();
    const loginFormRef = ref();
    const usernameRef = ref();
    const passwordRef = ref();
    const route = useRoute();
    const capsTooltip = ref(false);
    const loading = ref(false);
    const redirect = ref();
    const captchaImage = ref('');
    const otherQuery = ref();
    const store = useStore();
    watch(route, () => {
      const query = route.query;
      if (query) {
        redirect.value = query.redirect;
        otherQuery.value = queryStringToObj(redirect.value);
      }
    }, {
      immediate: true
    });
    refreshCaptcha();
    onMounted(() => {
      if (loginForm.username === '') {
        usernameRef.value?.focus();
      } else if (loginForm.password === '') {
        passwordRef.value?.focus();
      }
    });
    function checkCapslock(e) {
      const {
        key
      } = e;
      capsTooltip.value = !!key && key.length === 1 && key >= 'A' && key <= 'Z';
    }
    function refreshCaptcha() {
      getCaptcha().then(res => {
        captchaImage.value = res.data.image;
        loginForm.captchaId = res.data.id;
      });
    }
    function handleLogin() {
      loginFormRef.value?.validate(valid => {
        if (valid) {
          loading.value = true;
          store.user.login(loginForm).then(() => {
            router.push({
              path: redirect.value || '/',
              query: otherQuery.value
            });
            loading.value = false;
          }).catch(() => {
            refreshCaptcha();
            loading.value = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
    function queryStringToObj(queryString) {
      const urlObj = new URL('https://example.com' + queryString);
      const params = new URLSearchParams(urlObj.search);
      const obj = {};
      for (let [key, value] of params.entries()) {
        obj[key] = value;
      }
      return obj;
    }
    function getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    }
    return (_ctx, _cache) => {
      const _component_IEpUser = _resolveComponent("IEpUser");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_IEpKey = _resolveComponent("IEpKey");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_IEpLock = _resolveComponent("IEpLock");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Particle), _createElementVNode("div", _hoisted_2, [_createElementVNode("p", null, _toDisplayString(title.value), 1)]), _cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "login-left-box"
      }, null, -1)), _createVNode(_component_el_form, {
        ref_key: "loginFormRef",
        ref: loginFormRef,
        model: loginForm,
        rules: loginRules,
        class: "login-form",
        autocomplete: "on",
        "label-position": "left"
      }, {
        default: _withCtx(() => [_cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "title-container"
        }, [_createElementVNode("h1", {
          class: "title"
        }, "欢迎登录")], -1)), _createVNode(_component_el_form_item, {
          prop: "username"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            ref_key: "usernameRef",
            ref: usernameRef,
            modelValue: loginForm.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => loginForm.username = $event),
            placeholder: "用户名",
            name: "username",
            type: "text",
            tabindex: "1",
            maxlength: 20,
            autocomplete: "on"
          }, {
            prefix: _withCtx(() => [_createVNode(_component_IEpUser)]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_tooltip, {
          visible: capsTooltip.value,
          content: "大写已开启",
          placement: "right",
          manual: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "password"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              ref_key: "passwordRef",
              ref: passwordRef,
              modelValue: loginForm.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => loginForm.password = $event),
              type: "password",
              "show-password": "",
              "auto-complete": "on",
              placeholder: "密码",
              tabindex: "2",
              maxlength: 20,
              onKeypress: checkCapslock,
              onBlur: _cache[2] || (_cache[2] = $event => capsTooltip.value = false),
              onKeyup: _withKeys(handleLogin, ["enter"])
            }, {
              prefix: _withCtx(() => [_createVNode(_component_IEpKey)]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["visible"]), _createVNode(_component_el_form_item, {
          prop: "captchaCode"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            ref: "captchaCode",
            modelValue: loginForm.captchaCode,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => loginForm.captchaCode = $event),
            placeholder: "验证码",
            "auto-complete": "off",
            name: "captchaCode",
            maxlength: "4",
            tabindex: "3",
            style: {
              "width": "70%"
            },
            onKeyup: _withKeys(handleLogin, ["enter"])
          }, {
            prefix: _withCtx(() => [_createVNode(_component_IEpLock)]),
            _: 1
          }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
            class: "captcha",
            style: {
              "height": "38px",
              "cursor": "pointer",
              "width": "90px"
            },
            src: captchaImage.value,
            alt: "验证码",
            onClick: refreshCaptcha
          }, null, 8, _hoisted_4)])]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          style: {
            "width": "100%",
            "margin-bottom": "30px"
          },
          onClick: _withModifiers(handleLogin, ["prevent"])
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("登录 ")])),
          _: 1
        }, 8, ["loading"])]),
        _: 1
      }, 8, ["model"])]);
    };
  }
});